import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, PHONE_DISPLAY, PHONE_TEL } from "@/lib/content";
import { errorText } from "@/lib/errors";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export default function ManageGift() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("This link is missing its code. Please use the link from your thank-you email.");
      return;
    }
    axios.post(`${API}/donors/portal`, { token })
      .then(({ data }) => window.location.assign(data.url))
      .catch((err) => setError(errorText(err)));
  }, [params]);

  return (
    <div className="site bg-sage text-pine min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-6 py-24 md:py-32" data-testid="manage-gift-page">
        <p className="lb text-brass-ink">Your monthly gift</p>
        <h1 className="dp mt-6"><em>{error ? "We couldn't open it." : "One moment..."}</em></h1>
        <p className="mt-6 max-w-lg text-moss" data-testid="manage-gift-message">
          {error || "Taking you to the secure page where you can pause or cancel your monthly gift."}
        </p>
        {error && (
          <div className="mt-10 flex flex-wrap gap-6 items-center">
            <a href={PHONE_TEL} className="bg-pine text-sage rounded-full px-7 py-4" data-testid="manage-gift-call-button">Call {PHONE_DISPLAY}</a>
            <Link to="/" className="underline underline-offset-4 decoration-brass" data-testid="manage-gift-home-link">Back to home</Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
